<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Merchant Registration Requests</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">
                Merchant Registration Requests
              </li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="overlay" v-if="is_loading">
        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <div class="card-header">
              <h3 class="card-title">Detail</h3>
              <div class="card-tools">
                <router-link
                  class="btn btn-info"
                  :to="{ name: 'EWMerchantRegistrationRequestList' }"
                >
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="container mt-4">
                <div class="row">
                  <div class="col-md-6">
                    <h6 class="mb-3">Shop Information</h6>
                    <table class="table table-bordered small">
                      <tbody>
                        <tr>
                          <th>Shop Name</th>
                          <td>{{ value.shop_name }}</td>
                        </tr>
                        <tr>
                          <th>Corporate Id</th>
                          <td>{{ value.corporate_id ?? "" }}</td>
                        </tr>
                        <tr>
                          <th>Corporate Name</th>
                          <td>{{ value.corporate_name ?? "" }}</td>
                        </tr>
                        <tr>
                          <th>Country</th>
                          <td>{{ value.country?.name_en ?? '' }}</td>
                        </tr>
                        <tr>
                          <th>Province</th>
                          <td>{{ value.country?.name_en ?? '' }}</td>
                        </tr>
                        <tr>
                          <th>Address</th>
                          <td>{{ value.address ?? "NULL" }}</td>
                        </tr>
                        <tr>
                          <th>Contact Number</th>
                          <td>{{ value.contact_number }}</td>
                        </tr>
                        <tr>
                          <th>Shop Image</th>
                          <td>
                            <img
                              v-bind:src="
                                API_ASSET_UPLOAD_URL + value.shop_image
                              "
                              class="img-fluid img-thumbnail rounded"
                              style="width: 120px"
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>Shop Certificate</th>
                          <td>
                            <img
                              v-bind:src="
                                API_ASSET_UPLOAD_URL +
                                value.shop_certificate_image
                              "
                              class="img-fluid img-thumbnail rounded"
                              style="width: 120px"
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>Shop Logo</th>
                          <td>
                            <img
                              v-bind:src="
                                API_ASSET_UPLOAD_URL + value.shop_logo_image
                              "
                              class="img-fluid img-thumbnail rounded"
                              style="width: 120px"
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>Previous Id</th>
                          <td>{{ value.previous_user_id ?? "" }}</td>
                        </tr>
                        <tr>
                          <th>Status</th>
                          <td>{{ value.status }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Shop Owner Information -->
                  <div class="col-md-6">
                    <h6 class="mb-3">Shop Owner Information</h6>
                    <table class="table table-bordered small">
                      <tbody>
                        <tr>
                          <th>ID</th>
                          <td>{{ value.id }}</td>
                        </tr>
                        <tr>
                          <th>First Name</th>
                          <td>{{ value.first_name }}</td>
                        </tr>
                        <tr>
                          <th>Email</th>
                          <td>{{ value.email ?? "" }}</td>
                        </tr>
                        <tr>
                          <th>Gender</th>
                          <td>{{ value.gender }}</td>
                        </tr>
                        <tr>
                          <th>Date of Birth</th>
                          <td>{{ value.date_of_birth }}</td>
                        </tr>
                        <tr>
                          <th>Id Card Number</th>
                          <td>{{ value.id_card_number ?? "" }}</td>
                        </tr>
                        <tr>
                          <th>Id Card Picture</th>
                          <td>
                            <img
                              v-bind:src="
                                API_ASSET_UPLOAD_URL + value.id_card_picture
                              "
                              class="img-fluid img-thumbnail rounded"
                              style="width: 120px"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <br />

                    <!-- Button trigger modal approve-->
                    <div class="row mt-3">
                      <div class="col text-center">
                        <button
                          type="button"
                          class="btn btn-primary mr-4"
                          data-toggle="modal"
                          data-target="#approveModal"
                          @click="openModal"
                        >
                          Approve
                        </button>

                        <!-- Modal -->
                        <div
                          class="modal fade"
                          id="approveModal"
                          tabindex="-1"
                          role="dialog"
                          aria-label="Approve modal"
                          aria-hidden="true"
                        >
                          <div
                            class="modal-dialog modal-dialog-centered"
                            role="document"
                          >
                            <div class="modal-content">
                              <div class="modal-header justify-content-center">
                              <h5 class="modal-title font-weight-bold text-danger">Warning ⚠</h5>
                            </div>
                              <div class="modal-body">
                                Do you want to approve this registration
                                request?
                              </div>
                              <div class="modal-footer">
                                <button
                                  type="button"
                                  class="btn btn-secondary"
                                  data-dismiss="modal"
                                >
                                  Cancel
                                </button>
                                <button
                                  type="button"
                                  class="btn btn-primary"
                                  @click="approveRequest"
                                >
                                  Confrim
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <button
                          type="button"
                          class="btn btn-danger"
                          data-toggle="modal"
                          data-target="#rejectModal"
                          @click="openModal"
                        >
                          Reject
                        </button>

                        <!-- Modal -->
                        <div
                          class="modal fade"
                          id="rejectModal"
                          tabindex="-1"
                          role="dialog"
                          aria-label="Reject modal"
                          aria-hidden="true"
                        >
                          <div
                            class="modal-dialog modal-dialog-centered"
                            role="document"
                          >
                            <div class="modal-content">
                              <div class="modal-header justify-content-center">
                              <h5 class="modal-title font-weight-bold text-danger">Warning ⚠</h5>
                            </div>
                              <div class="modal-body">
                                Do you want to reject this registration
                                request?
                              </div>
                              <div class="modal-footer">
                                <button
                                  type="button"
                                  class="btn btn-secondary"
                                  data-dismiss="modal"
                                >
                                  Cancel
                                </button>
                                <button
                                  type="button"
                                  class="btn btn-primary"
                                  @click="rejectRequest"
                                >
                                  Confrim
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";
import { DepartmentsAPI } from "@/services/api";
import axios from "axios";
import { Notification } from "element-ui";
const fileDownload = require("js-file-download");

export default {
  name: "EWMerchantRegistrationRequestShow",
  metaInfo: {
    title: "EW Merchant Registration Request | Dotlines",
  },
  data: () => ({
    showModal: true,
    is_loading: false,
    value: {},
    pre: {},
  }),
  mounted: function () {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      await this.getDetail(this.params.id).then((response) => {
        this.value = response.data;
      });

      this.is_loading = false;
    },
    downloadFile: function (url) {
      this.is_loading = true;
      axios
        .get(this.API_ASSET_UPLOAD_URL + url, { responseType: "arraybuffer" })
        .then((response) => {
          fileDownload(response.data, url.replaceAll("/", "-"));
          Notification.success({
            title: "Download Completed",
            message: "Download completed successfully",
            type: "success",
          });
        })
        .catch((error) => {
          Notification.error({
            title: "Download Failed",
            message: "Failed to download",
            type: "error",
          });
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line camelcase
        const api_url = "/ew_merchant_registration_requests/" + id;
        axios
          .get(api_url)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            console.log("error " + error);
            reject(error);
          })
          .finally(() => {});
      });
    },
    openModal(modalId) {
      $(`#${modalId}`).modal("show");
    },
    rejectRequest() {
      let _this = this;
      _this.is_loading = true;
      _this.value.status = "Reject";

      let api_url = `/ew_merchant_registration_requests/${_this.$route.params.id}`;
      let method = "PUT";
      axios({
        method: method,
        url: api_url,
        data: _this.value,
        headers: { "Content-Type": "application/json" },
      })
        .then(function (response) {
          _this.$toaster.success(response.data.message);

          let modal = document.getElementById("rejectModal");
          let backdrop = document.querySelector(".modal-backdrop");
          if (modal) {
            modal.classList.remove("show");
            modal.style.display = "none";
          }
          if (backdrop) {
            backdrop.remove();
          }
          document.body.classList.remove("modal-open");

          _this.$router.push({ name: "EWMerchantRegistrationRequestList" });
        })
        .catch((errors) => {
          if (errors.response.status === 500) {
            _this.$toaster.error(errors.response.data.message);
          }
          _this.$setErrorsFromResponse(errors.response.data);
        })
        .finally(() => {
          _this.is_loading = false;
        });
    },

    approveRequest() {
      let _this = this;
      _this.is_loading = true;
      _this.value.status = "Approved";

      let api_url = `/ew_merchant_registration_requests/${_this.$route.params.id}`;
      let method = "PUT";

      axios({
        method: method,
        url: api_url,
        data: _this.value,
      })
        .then((response) => {
          return axios
            .post("/approved-merchant-request", _this.value)
            .then((approveResponse) => {
              _this.$toaster.success(
                approveResponse.data.message ||
                  "Merchant request approved successfully!"
              );
              let modal = document.getElementById("rejectModal");
              let backdrop = document.querySelector(".modal-backdrop");
              if (modal) {
                modal.classList.remove("show");
                modal.style.display = "none";
              }
              if (backdrop) {
                backdrop.remove();
              }
              document.body.classList.remove("modal-open");

              _this.$router.push({ name: "EWMerchantRegistrationRequestList" });
            });
        })
        .catch((errors) => {
          if (errors.response && errors.response.status === 500) {
            _this.$toaster.error(errors.response.data.message);
          }
          _this.$setErrorsFromResponse(errors.response?.data || {});
        })
        .finally(() => {
          _this.is_loading = false;
        });
    },
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
};
</script>
